import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconUpdate.tsx
const OutlinedFilledUpdate = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M483.81-95q-79.48 0-150.64-30.5Q262-156 209.5-208.5t-83.5-123Q95-402 95-482t31-149.5Q157-701 209.5-753t123.73-82.5Q404.46-866 484-866q81 0 153.5 34T766-739v-95h71v227H608v-73h84q-42.27-42.27-95.64-66.63Q543-771 484-771q-122 0-208 82.82t-86 203Q190-362 275.37-275.5 360.75-189 484-189q120 0 203.38-85.35Q770.75-359.7 772-481h94q0 161-111 273.5T483.81-95ZM600-311 446-463v-220h71v189l135 131-52 52Z" })
});
const OutlinedUpdate = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M483.81-95q-79.48 0-150.64-30.5Q262-156 209.5-208.5t-83.5-123Q95-402 95-482t31-149.5Q157-701 209.5-753t123.73-82.5Q404.46-866 484-866q81 0 153.5 34T766-739v-95h71v227H608v-73h84q-42.27-42.27-95.64-66.63Q543-771 484-771q-122 0-208 82.82t-86 203Q190-362 275.37-275.5 360.75-189 484-189q120 0 203.38-85.35Q770.75-359.7 772-481h94q0 161-111 273.5T483.81-95ZM600-311 446-463v-220h71v189l135 131-52 52Z" })
});
const RoundedFilledUpdate = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M483.88-95Q404-95 333-125.5t-123.5-83Q157-261 126-331.5T95-482q0-80 31-149.5T209.5-753q52.5-52 123.73-82.5T484-866q81 0 153.5 34T766-739v-60q0-15.15 10-25.08 10-9.92 25.5-9.92t25.5 9.92q10 9.93 10 25.08v145q0 20-13.5 33.5T790-607H644q-14.72 0-25.36-10.5Q608-628 608-643.5t10-26q10-10.5 26-10.5h48q-42.27-42.27-95.64-66.63Q543-771 484-771q-122 0-208 82.82t-86 203Q190-362 275.37-275.5 360.75-189 484-189q110.33 0 188.66-72Q751-333 766-438q4-19 18.5-30.5t33.56-10.5Q838-478 851-464q13 14 10 32-17.35 143.12-123.67 240.06Q631-95 483.88-95ZM517-493.74l107.8 104.57Q637-377 637-362.63q0 14.36-11.51 25.63-11.5 12-25.74 12-14.24 0-25.75-12L459-450q-7-6-10-14.35T446-483v-165q0-15.15 10.39-25.08 10.4-9.92 25.5-9.92 15.11 0 25.11 9.92 10 9.93 10 25.08v154.26Z" })
});
const RoundedUpdate = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M483.88-95Q404-95 333-125.5t-123.5-83Q157-261 126-331.5T95-482q0-80 31-149.5T209.5-753q52.5-52 123.73-82.5T484-866q81 0 153.5 34T766-739v-60q0-15.15 10-25.08 10-9.92 25.5-9.92t25.5 9.92q10 9.93 10 25.08v145q0 20-13.5 33.5T790-607H644q-14.72 0-25.36-10.5Q608-628 608-643.5t10-26q10-10.5 26-10.5h48q-42.27-42.27-95.64-66.63Q543-771 484-771q-122 0-208 82.82t-86 203Q190-362 275.37-275.5 360.75-189 484-189q110.33 0 188.66-72Q751-333 766-438q4-19 18.5-30.5t33.56-10.5Q838-478 851-464q13 14 10 32-17.35 143.12-123.67 240.06Q631-95 483.88-95ZM517-493.74l107.8 104.57Q637-377 637-362.63q0 14.36-11.51 25.63-11.5 12-25.74 12-14.24 0-25.75-12L459-450q-7-6-10-14.35T446-483v-165q0-15.15 10.39-25.08 10.4-9.92 25.5-9.92 15.11 0 25.11 9.92 10 9.93 10 25.08v154.26Z" })
});
const SharpFilledUpdate = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M483.81-95q-79.48 0-150.64-30.5Q262-156 209.5-208.5t-83.5-123Q95-402 95-482t31-149.5Q157-701 209.5-753t123.73-82.5Q404.46-866 484-866q81 0 153.5 34T766-739v-95h71v227H608v-73h84q-42.27-42.27-95.64-66.63Q543-771 484-771q-122 0-208 82.82t-86 203Q190-362 275.37-275.5 360.75-189 484-189q120 0 203.38-85.35Q770.75-359.7 772-481h94q0 161-111 273.5T483.81-95ZM600-311 446-463v-220h71v189l135 131-52 52Z" })
});
const SharpUpdate = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M483.81-95q-79.48 0-150.64-30.5Q262-156 209.5-208.5t-83.5-123Q95-402 95-482t31-149.5Q157-701 209.5-753t123.73-82.5Q404.46-866 484-866q81 0 153.5 34T766-739v-95h71v227H608v-73h84q-42.27-42.27-95.64-66.63Q543-771 484-771q-122 0-208 82.82t-86 203Q190-362 275.37-275.5 360.75-189 484-189q120 0 203.38-85.35Q770.75-359.7 772-481h94q0 161-111 273.5T483.81-95ZM600-311 446-463v-220h71v189l135 131-52 52Z" })
});
const componentMap = {
	outlined: OutlinedUpdate,
	"outlined-fill": OutlinedFilledUpdate,
	rounded: RoundedUpdate,
	"rounded-fill": RoundedFilledUpdate,
	sharp: SharpUpdate,
	"sharp-fill": SharpFilledUpdate
};
const IconUpdate = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconUpdate };